// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2RBfM","resendInfoText":"OnGoingPaymentBox_resendInfoText__2mVe0"};